import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { filterTypeI18nKey } from '../components/filter/filter.type';

@Pipe({
    name: 'filterTypeLabel',
    pure: false,
    standalone: false
})
export class FilterTypeLabelPipe implements PipeTransform {

    constructor(private translate: TranslateService) {
    }

    transform(code: unknown, variableType?: string): string {
        if (code === null || code === undefined || code === '') {
            return '';
        }
        const key = filterTypeI18nKey(code, variableType);
        return key ? this.translate.instant(key) : String(code);
    }
}
